import { API } from "./queries";

/** 
  The url function construct full query 
  @params 
    query: One of query from list of all available queries
    id: identifier of a single object, default empty string
  @return constructed query to perform request
*/
export default function url(query, id = "") {
  return `${API}${query}${id ? `/${id}` : ""}`;
}
